<template>
  <div class="vx-row w-full skeleton-loading-card mt-2">
    <div class="mr-3 mb-3 data-card-outline" v-for="index in count" :key="index">
      <div :class="extraButtons ? 'bigger-card' :''" class="data-card" >
        <div class="data-card-header b-skeleton dashboard-skeleton b-skeleton-text b-skeleton-animate-wave">
        </div>
        <div :class="extraButtons ? 'bigger-card-content' :''" class="data-card-content">
          <div class="data-label">
            <custom-skeleton animation="wave" type="text" :count="1" height="21px" width="70px"></custom-skeleton>
            <custom-skeleton animation="wave" type="text" :count="1" height="21px" width="46px"></custom-skeleton>
          </div>
          <custom-skeleton animation="wave" type="text" :count="1" height="50px" width="250px"></custom-skeleton>
          <custom-skeleton class="absolute score" animation="wave" type="text" :count="1" height="17px" width="44px"></custom-skeleton>
          <custom-skeleton animation="wave" type="avatar" :count="1" height="110px" width="110px"></custom-skeleton>
          <div v-if="extraButtons" class="data-label mt-2">
            <custom-skeleton animation="wave" type="text" :count="1" height="35px" width="125px"></custom-skeleton>
            <custom-skeleton animation="wave" type="text" :count="1" height="35px" width="125px"></custom-skeleton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomRadialChart from './CustomRadialChart.vue'
import DoubleSlider from './DoubleSlider.vue'
import CustomSkeleton from './CustomSkeleton.vue'

export default {
  data(){
    return{
    }
  },
  components:{
    CustomRadialChart,
    DoubleSlider,
    CustomSkeleton
  },
  props:{
    count: {
      type: Number,
      required: true
    },
    extraButtons:{
      type: Boolean,
      required: false
    }
  },
  methods:{
    

  },
  mounted(){
  },
  
}
</script>



<style scoped lang="scss">
.skeleton-loading-card{
  .bigger-card{
    height: 310px !important;
  }
  .data-card{
    box-shadow: 3px 3px 6px 3px rgba(0, 0, 0, 0.2) !important;
    transition: transform .15s ease-in, box-shadow .2s ease-in;
    border-radius: 15px;
    width: 300px;
    height: 290px;
    cursor: pointer;
    &:hover {
      transform: scale(1.035);
      box-shadow: 0px 5px 6px 3px rgba(0, 0, 0, 0.3) !important;
    }
    .data-card-header{
      padding: 5px;
      height: 60px;
      margin-bottom: 0px;
      border-radius: 15px 15px 0px 0px;
      //background-color: rgba(var(--vs-primary),100);
      background: linear-gradient(to right, rgba(var(--vs-primary), 1), rgba(var(--vs-secondary), 1));
      display: flex;
      h1{
        font-size: 24px;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: auto;
      }
    }
    .bigger-card-content{
      height: 250px !important;
    }
    .data-card-content{
      padding: 10px 10px 20px 10px;
      position: relative;
      background-color: #101738;
      height: 230px;
      border-radius: 0px 0px 15px 15px ;
      .score{
        left: 10px;
      }
      h6{
        position: absolute;
      }
      .h6-lower{
        top: 42px;
      }
    }
    .data-label{
      display: flex;
      justify-content: space-evenly;
      flex-direction: row;
      .data-my-avg::before{
        background-color: rgba(var(--vs-primary),100)
      }
      .data-avg::before{
        background-color: white;
      }
      p::before{
        content: '';
        border-radius: 50%;
        height: 10px;
        width: 10px;
        margin-right: 5px;
        display: inline-block;
      }
    }
    .radial-move{
      margin-top: -20px;
      justify-content: center;
    }
  }
}

</style>
